import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, TextField, makeStyles } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const useStyles = makeStyles(() => ({
  schedulerContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    maxHeight: '25em',
    overflow: 'auto',
    width: '100%'
  },
  schedule: {
    border: '1px solid #bbb6b6',
    borderRadius: '5px',
    padding: '5px',
    margin: '0.5em',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(33% - 1.5rem)'
  }
}))

const EventEditor = (props) => {
  const { edits, schedules, scheduledEventProps, setScheduledEventProps } =
    props
  const title = edits.title
  const classes = useStyles()

  const numEvents = Object.keys(scheduledEventProps).length
  const handleEventTitleChange = (eventDate, eventTitle) => {
    setScheduledEventProps({
      ...scheduledEventProps,
      [eventDate]: {
        ...scheduledEventProps[eventDate],
        title: eventTitle,
      },
    })
  }

  if (numEvents === 0) return null

  return (
    <div style={{ marginTop: '0.5em' }}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          Scheduled Events ({numEvents})
        </AccordionSummary>
        <AccordionDetails>
          <div
          className={classes.schedulerContainer}
          >
            {Object.values(scheduledEventProps).map((event) => {
              return (
                <div
                  className={classes.schedule}
                >
                  <TextField
                    variant='outlined'
                    size='small'
                    value={event.title || title}
                    onChange={(ev) =>
                      handleEventTitleChange(
                        event.startDateTime,
                        ev.target.value
                      )
                    }
                  />
                  <span>{event.startDateTime.format('MM/DD/YYYY')}</span>
                </div>
              )
            })}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default EventEditor
